import { isPlatformBrowser } from '@angular/common';
import { Injectable, Inject, NgZone, PLATFORM_ID } from '@angular/core';
import { PostHogConsentService } from './posthog-consent.service';
import { loadPosthog } from './posthog-client';

let postHogInitialized = false;

export function isPostHogInitialized(): boolean {
  return postHogInitialized;
}

export function initPostHog(ph: PostHogInitService) {
  return () => ph.init();
}

@Injectable({
  providedIn: 'root'
})
export class PostHogInitService {
  constructor(@Inject('AppConfig') private appConfig: any,
              @Inject(PLATFORM_ID) private platformId: any,
              private ngZone: NgZone,
              private postHogConsentService: PostHogConsentService) { }

  async init(): Promise<boolean> {
    const { analytic } = this.appConfig;

    if (isPlatformBrowser(this.platformId) && analytic?.postHog) {
      const posthog = await loadPosthog();
      this.ngZone.runOutsideAngular(() => {
          posthog.init(analytic?.postHog, {
            api_host: 'https://eu.i.posthog.com',
            cookieless_mode: 'on_reject',
            person_profiles: 'identified_only',
            capture_pageview: false,
            capture_pageleave: true,
            autocapture: true,
            disable_session_recording: false,
            bootstrap: { featureFlags: {} },
            loaded: () => {
              console.log('PostHog initialized and feature flags loaded');
            },
            session_recording: {
              maskAllInputs: true,
              maskTextSelector: '.sensitive-data',
            },
          } as Parameters<typeof posthog.init>[1] & { cookieless_mode: 'on_reject' });
          postHogInitialized = true;
          this.postHogConsentService.init();
      });
    }

    return true;
  }
}
